/**
 * Query key factory for consistent cache management.
 * Using this factory ensures that queries are properly invalidated when needed.
 */

/**
 * Creates query keys for workspace-dependent resources
 */
export const queryKeys = {
  // Dashboard data
  dashboard: (workspaceId?: string) => ['dashboard-data', workspaceId],
  
  // CRM data
  contacts: (workspaceId?: string) => ['contacts', workspaceId],
  companies: (workspaceId?: string) => ['companies', workspaceId],
  
  // Pipeline data
  pipeline: (workspaceId?: string) => ['pipeline-data', workspaceId],
  fulfillment: (workspaceId?: string) => ['fulfillment-data', workspaceId],
  
  // Project management
  projects: (workspaceId?: string) => ['crm_projects', workspaceId],
  tasks: (workspaceId?: string) => ['tasks', workspaceId],
  
  // Analytics and reporting
  analytics: (workspaceId?: string) => ['analytics', workspaceId],
  reports: (workspaceId?: string) => ['reports', workspaceId],
  
  // Admin settings
  columnConfig: (workspaceId?: string) => ['columnConfig', workspaceId],
  planning: (workspaceId?: string) => ['planning-data', workspaceId],
  teamManagement: (workspaceId?: string) => ['team-management', workspaceId],
  customization: (workspaceId?: string) => ['customization', workspaceId],
  
  // Copilot data
  copilot: {
    threads: (userId?: string) => ['copilot', 'threads', userId],
    assistants: () => ['copilot', 'assistants'],
    functions: () => ['copilot', 'functions'],
    messages: (threadId?: string) => ['copilot', 'messages', threadId],
    messagesPaginated: (threadId?: string) => ['copilot', 'messages-paginated', threadId],
    userPreferences: (userId?: string) => ['copilot', 'userPreferences', userId],
    dashboardData: (userId?: string) => ['copilot', 'dashboardData', userId],
  },
  
  // Helper function for creating nested query keys
  withId: (baseKey: string[], id: string) => [...baseKey, id],
  withFilter: (baseKey: string[], filter: Record<string, any>) => [...baseKey, filter],
} as const;

/**
 * Creates query keys for user-specific resources (not workspace-dependent)
 */
export const userQueryKeys = {
  notifications: (userId?: string) => ['notifications', userId],
  userTasks: (userId?: string) => ['user-tasks', userId],
  files: (userId?: string) => ['files', userId],
  research: () => ['research'],
  aiUsageData: (userId?: string) => ['ai-usage-data', userId],
  usageOverview: (userId?: string, timeRange?: string) => ['usage-overview', userId, timeRange],
  usageAnalytics: (userId?: string, timeRange?: string) => ['usage-analytics', userId, timeRange],
  usageLogs: (userId?: string, timeRange?: string, limit?: number, offset?: number, appFilter?: string, serviceFilter?: string) => 
    ['usage-logs', userId, timeRange, limit, offset, appFilter, serviceFilter],
  costSummary: (userId?: string, timeRange?: string) => ['cost-summary', userId, timeRange],
};
